import React from 'react';
import { Edit3, Trash2 } from 'lucide-react';

export const ProductRow = ({ product, onEdit, onDelete }) => {
  const isLowStock = product.min_stock > 0 && product.current_stock <= product.min_stock;
  const isExpiringSoon = (() => {
    if (!product.expiry_date) return false;
    const exp = new Date(product.expiry_date);
    const warn = new Date();
    warn.setMonth(warn.getMonth() + (product.expiry_warning_months || 3));
    return exp <= warn;
  })();
  const isExpired = product.expiry_date && new Date(product.expiry_date) < new Date();

  return (
    <div className="px-3 py-2 flex items-center gap-2" data-testid={`product-${product.id}`}>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-1.5">
          <p className="font-medium text-gray-900 text-sm truncate">{product.name}</p>
          {isExpired && <span className="text-[9px] bg-red-100 text-red-600 px-1.5 py-px rounded-full shrink-0">SKT!</span>}
          {!isExpired && isExpiringSoon && <span className="text-[9px] bg-orange-100 text-orange-600 px-1.5 py-px rounded-full shrink-0">SKT</span>}
          {isLowStock && <span className="text-[9px] bg-red-100 text-red-600 px-1.5 py-px rounded-full shrink-0">Az</span>}
        </div>
        <div className="flex items-center gap-2 text-[10px] text-[#8E8E93] mt-px">
          <span className={`font-medium ${isLowStock ? 'text-red-500' : 'text-gray-600'}`}>{product.current_stock} adet</span>
          {product.default_price > 0 && <span className="text-green-600">{product.default_price}&#8378;</span>}
          {product.cost_price > 0 && <span className="text-orange-500">{product.cost_price}&#8378; G</span>}
          {product.barcode && <span>{product.barcode}</span>}
          {product.expiry_date && <span>SKT: {new Date(product.expiry_date).toLocaleDateString('tr-TR')}</span>}
        </div>
      </div>
      <div className="flex items-center shrink-0">
        <button onClick={() => onEdit({ ...product })} className="p-1.5 rounded-full hover:bg-blue-50 text-[#6b6de3]" data-testid={`edit-product-${product.id}`}>
          <Edit3 size={14} />
        </button>
        <button onClick={() => onDelete(product.id, product.name)} className="p-1.5 rounded-full hover:bg-red-100 text-[#8E8E93] hover:text-red-500">
          <Trash2 size={14} />
        </button>
      </div>
    </div>
  );
};
